module.exports = __webpack_public_path__ + "img/consultantbg01.f7df5a17.jpg";